import React, {useState} from 'react';
import CallCenterStructure from '../CallCenterStructure/CallCenterStructure';
import Dropdown from '../../component/DropDown/DropDown';
import DownloadButtonPdf from '../../component/DownloadButtonPdf/DownloadButtonPdf';
import DownloadButtonXlsx from '../../component/DownloadButtonXlsx/DownloadButtonXlsx';
import RadioButtonSingle from '../../component/RadioButtonSingle/RadioButtonSingle';

const EmailSmsDetailReport = ()=>{
    const [selectedOption, setSelectedOption] = useState(null);

    const handleRadioButtonChange = value => {
      setSelectedOption(value);
    };
  const data = [
    {
    receipt: '#75588', membId: '67', transDate:'23/06/2023', membName:'Kenneth', 
    billAmount:5000, redeemAmount:8000, balPaid:16000, pointsGained:8
    }
  ];
    return(
    <>
        <CallCenterStructure>
        <div className='mt-5 p-4'>
           <h4 className='pb-4'>Email/SMS Detail Report</h4>
           <main className='border border-light p-3'>
           <form action="">
               <div className="row">
               <div className="form-group col-12 col-md-6" >
               <label className='d-flex justify-content-between' htmlFor="fromDate">From Date *</label>
                   <input className="w-100" type="text" placeholder='From date' />
               </div>
               <div className="form-group col-12 col-md-6" >
               <label className='d-flex justify-content-between' htmlFor="tillDate">Till Date *</label>
                   <input className="w-100" type="text" placeholder='Till date' />
               </div>
               </div>

               <div className="row">
               <div className="form-group col-12 col-md-3 d-flex" >
                {/* <p><label htmlFor="selectRedemptionMethod">Redemption Method *</label></p> */}
                <div className="d-flex mr-5 mt-4">
                 <RadioButtonSingle
                        name="channel"
                        value="email"
                        selected={selectedOption === 'email'}
                        borderWidth={2}
                        borderHeight={2}
                        onChange={handleRadioButtonChange}
                   />Email
                </div>
                <div className="d-flex mt-4">
                 <RadioButtonSingle
                        name="channel"
                        value="sms"
                        selected={selectedOption === 'sms'}
                        borderWidth={2}
                        borderHeight={2}
                        onChange={handleRadioButtonChange}
                   />SMS
                </div>
               </div>
               <div className="form-group col-12 col-md-4" >
                   <label htmlFor="selectEmailType">Select Email Type *</label>
                   <Dropdown/>
               </div>
               <div className="form-group col-12 col-md-4" >
                   <label htmlFor="selectView">Select View *</label>
                   <Dropdown/>
               </div>
               </div>

               <div className='form-group d-flex justify-content-between d-md-flex justify-content-md-start'>
                   <button className='mr-5'>Submit</button>
                </div>
           </form>
           </main>
           <div className='mt-4 d-flex justify-content-between d-md-flex justify-content-md-start'>
           <DownloadButtonPdf />
           <DownloadButtonXlsx />
           </div>
          
           <section className="border border-light mt-4 mb-4">
                <div className="row p-4">
                <div className="col-12 table-responsive">
                <table className='table'>
                    <thead>
                        <tr>
                        <th className=''>Email Date</th>
                        <th className=''>Email Type</th>
                        <th className=''>Member Name</th>
                        <th className=''>Membership ID</th>
                        <th className=''>User type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((each, index) =>(
                             <tr key={index}>
                                <td>{each.receipt}</td>
                                <td>{each.transDate}</td>
                                <td>{each.membId}</td>
                                <td>{each.membName}</td>
                                <td>{each.billAmount}</td>
                             </tr>
                            ))
                        }
                    </tbody>
                </table>
                </div>
                <div className="col-12">Pagination</div>
                </div>
           </section>
           
        </div>
       </CallCenterStructure>
    </>
    );
}
export default EmailSmsDetailReport;